import { Stack, StackProps, Typography } from '@mui/material';
import { COLOR_BG_SECONDARY } from 'shared';
import { useCountdown } from 'shared/hooks';

interface PaymentCountdownProps {
  endTime: number;
  onTimeout: () => void;
}

export const padUnit = (value: number | string) => String(value).padStart(2, '0');

export const PaymentCountdown = ({ endTime, onTimeout, ...props }: PaymentCountdownProps & StackProps) => {
  const timeLeft = useCountdown({
    endTime,
    onTimeout,
  });

  return (
    <Stack
      width="100%"
      borderRadius={3}
      bgcolor={COLOR_BG_SECONDARY}
      alignItems="center"
      justifyContent="center"
      p={1.5}
      {...props}
    >
      <Typography variant="body2" className="accent">
        {`${padUnit(timeLeft.hours)}h:${padUnit(timeLeft.minutes)}m:${padUnit(timeLeft.seconds)}s`}
      </Typography>
    </Stack>
  );
};
